<template>
    <v-dialog v-model="dialog" scrollable max-width="1000px">
        <v-card tile class="grey darken-3" :light="false">
            <v-app-bar dense color="blue-grey darken-2">
                <v-toolbar-title>Auswahl</v-toolbar-title>
                <!-- <v-spacer></v-spacer> -->
                <v-text-field flat solo dense hide-details label="Suche" prepend-inner-icon="mdi-magnify" background-color="blue-grey darken-3"
                    v-model="search" clearable class="shrink mx-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn icon>
                    <v-icon>mdi-reload</v-icon>
                </v-btn>
            </v-app-bar>
            <v-list-item>
              <v-list-item-content class="black--text">
                <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" @ready="onReady"></ckeditor>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
            <v-btn text class="warning" @click="onCancel()">Abbrechen</v-btn>
            <v-spacer />
            <v-btn text class="success" @click="onSubmit()">Speichern</v-btn>
            <v-spacer />
            <v-btn text class="primary" @click="onOpen()">Öffnen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import CustomEditor from '../../plugins/document/ckeditor';
//import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/de';

export default {
  name: 'Cke',
  components: {
            //ckeditor: CKEditor.component
  },
  data: () => ({
      loading: false,
      dialog: false,
      search: null,
      editor: CustomEditor,
      editorData: '<table border="0" cellpadding="0" cellspacing="0" style="width:100%; margin: 0; padding: 0"><tr><td>A<hr></td><td>B</td></tr></table>',
      editorConfig: {
          toolbar: {
            shouldNotGroupWhenFull: true,
              items: [
                'undo',
                'redo',
                '|',
                'bold',
                'underline',
                'italic',
                '|',
                'alignment',
                '|',
                'outdent',
                'indent',
                '|',
                'fontFamily',
                'fontSize',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'fontColor',
                'fontBackgroundColor',
                '|',
                'pageBreak',
                '|',
                'removeFormat',
                '|',
                'heading',
              ]
         },
          language: 'de',
      },
  }),
  methods: {
		async saveData() {
			this.loading = true
			const param = {
				data: { text: this.editorData }
			}
            try {
                await this.$store.dispatch('core/saveItem', param)
				//this.closeDialog('submitted')
        	} catch (error) {
                console.error(error)
				console.log(error.response)
				//console.log(error.response.data.message)
				//this.msgError(error.response.data)
                /*this.message.status = error.response.status
                this.message.data = error.response.data
                this.message.title = error.name
                this.message.msg = '<code>' + JSON.stringify(error.response.data).substring(0, 200) + '</code>'
                this.showmessage = true*/
            } finally {
                this.loading = false
            }
		},
            onCancel() {
                this.$emit('cancel')
                this.dialog = false
            },
            onSubmit() {
                //console.log('selected:', this.selectedItem)
                //this.$emit('submit', this.filteredItems[this.selectedItem])
                //this.dialog = false
                this.saveData()
            },
            onOpen() {
                const path = '/printgetdoc'
                //window.open(document.location.origin + path, "_blank")
                window.open('http://quarx-next.test' + path, "_blank")
            },
      onReady( editor )  {
          editor.ui.getEditableElement().parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement()
          );
          //console.log(Array.from( editor.ui.componentFactory.names() ))
      },
      onClick(e) {
      	console.log(e)
      	console.log(this.editorData)
      }
  },
		mounted() {
            console.log('dialog three mounted')
            this.dialog = true
        },
        beforeDestroy() {
            console.log('destroying dialog three')
        },
	  	watch: {

        },

};
</script>
<style>
.ck-toolbar {
    background-color: #aaaaaa !important;
}
.ck-content {
    background-color: #aaaaaa !important;
}
.ck-editor__editable_inline {
    height: 400px;
}
</style>
